import { AnyComponentStructure } from '@start-set/wakadoo-editor-core/Types';
import { privateTemplateModuleAPI } from '../../../../entities/module/private-template-module/api/api';
import { privateTemplateModuleTagAPI } from '../../../../entities/module/private-template-module-tag/api/api';
import { ERROR_MESSAGE_LIST, notificationError } from '../../../../components/Notifications/callNotifcation';
import { useAppDispatch } from '../../../../shared/libs/redux';
import {
	setCreateModuleWindowClose, setCreateModuleWindowOpen,
	setWindowModuleOpen,
} from '../../../../entities/module/private-template-module/model/slice';

export const useCreateModule = (
	preview: string,
	selectedCategoriesIds: string[],
	selectedTagsIds: string[],
	selectedLegalEntityId: string[],
	structure: AnyComponentStructure | null,
) => {
	const dispatch = useAppDispatch();

	const [createModule, { isLoading }] = privateTemplateModuleAPI.useCreateMutation();

	const onCreateModule = async (
		name: string,
		description: string,
	) => {
		if (!structure) return;

		try {
			const preparedTags = selectedTagsIds.map(id => Number(id));
			const preparedCategories = selectedCategoriesIds.map(id => Number(id));

			try {
				await createModule({
					name,
					tags: preparedTags,
					description,
					preview,
					rootComponent: structure,
					categories: preparedCategories,
					legalEntities: selectedLegalEntityId,
				})
					.unwrap();
				dispatch(privateTemplateModuleTagAPI.util?.invalidateTags(['tag']));
				dispatch(setCreateModuleWindowOpen({ active: false }));
				dispatch(setWindowModuleOpen());
			} catch (err) {
				notificationError(
					ERROR_MESSAGE_LIST.ERROR,
					'Мы уже устраняем эту проблему!',
				);
			}
		} catch (err) {
			notificationError(
				'Что-то пошло не так...',
				'Мы уже устраняем эту проблему!',
			);
		}
	};

	return {
		onCreateModule,
		isLoading,
	};
};
